// extracted by mini-css-extract-plugin
module.exports = {"row3":"Organization_row3__2RkPZ","grid":"Organization_grid__1PQBR","bottom":"Organization_bottom__133_k"};